import Close from 'apollo-react-icons/Close';
import Upload from 'apollo-react-icons/Upload';
import Button from 'apollo-react/components/Button';
import Card from 'apollo-react/components/Card';
import CardContent from 'apollo-react/components/CardContent';
import CardHeader from 'apollo-react/components/CardHeader';
import Container from 'apollo-react/components/Container';
import DatePicker from 'apollo-react/components/DatePicker';
import Divider from 'apollo-react/components/Divider';
import FileUpload from 'apollo-react/components/FileUpload';
import Grid from 'apollo-react/components/Grid';
import InputLabel from 'apollo-react/components/InputLabel';
import Radio from 'apollo-react/components/Radio';
import TextField from 'apollo-react/components/TextField';
import TimePicker from 'apollo-react/components/TimePicker';
import Typography from 'apollo-react/components/Typography';
import { unionWith } from 'lodash';
import dayjs from 'dayjs';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import ConfirmDialog from '../common/ConfirmDialog';
import { API_URL, NO_SEND_FLG, OBJ_ROLE, PROMPTLY_FLG, SYS_ROLE } from '../common/Constants';
import DetailDialog from '../common/DetailDialog';
import Dialog from '../common/Dialog';
import Loading from '../common/Loading';
import { checkFileName, getFuncroleFlg, postApi, setMessage, setURL, toISOStringWithTimezone, redirectToLogin, getBlockedExtensions, isBlockedExtension, CustomApiError } from '../common/Utils';
import './UploadDelivery.scss';

// スピナー表示　改善
//import { CircularProgress } from '@mui/material';

/**
 * 納品アップロード
 */
function UploadDelivery() {
	const location = useLocation();
	const [t, i18n] = useTranslation();
	const navigate = useNavigate();
	const [isLoading, setIsLoading] = useState(true);
	const DIALOG_STATUS = {
		NO_DIALOG: '0',
		OK_DIALOG: '1',
		DETAIL_DIALOG: '2',
		UPLOAD_CONFIRM_DIALOG: '3',
		UPLOAD_COMPLETE_DIALOG: '4',
	};

	// ファイル保管期間の定数を追加
	const FILE_PERIOD = {
		DAYS_15: '15',
		DAYS_30: '30',
		DAYS_45: '45',
		DAYS_60: '60',
		DAYS_75: '75',
		DAYS_90: '90',
	};

	const [dialogStatus, setDialogStatus] = useState(DIALOG_STATUS.NO_DIALOG);
	const [dialogOpen, setDialogOpen] = useState(false);
	const [dialogContent, setDialogContent] = useState('');
	const [detailContent, setDetailContent] = useState('');
	const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
	const [confirmDialogContent, setConfirmDialogContent] = useState('');
	// スピナー表示　改善
	//const [isUploading, setIsUploading] = useState(false);
	const [showProgress, setShowProgress] = useState(false);
	const [progressValue, setProgressValue] = useState(0);
	const [uploadStatus, setUploadStatus] = useState('');

	// ファイル選択の権限フラグ
	const [uploadFileSelectorAuthFlg, setUploadFileSelectorAuthFlg] = useState(false);
	// 特記事項の権限フラグ
	const [noticeAuthFlg, setNoticeAuthFlg] = useState(false);
	// お知らせの権限フラグ
	const [informationAuthFlg, setInformationAuthFlg] = useState(false);
	// 公開日時の権限フラグ
	const [openDateChkAuthFlg, setOpenDateChkAuthFlg] = useState(false);
	// 通知メールの送信の権限フラグ
	const [mailSendChkAuthFlg, setMailSendChkAuthFlg] = useState(false);
	// アップロードボタンの権限フラグ
	const [uploadFileBtnAuthFlg, setUploadFileBtnAuthFlg] = useState(false);
	// 画面に表示されている情報
	const [formValues, setFormValues] = useState({
		orgCode: '',
		orgName: '',
		serviceCode: '',
		serviceName: '',
		projCode: '',
		projName: '',
		selectedFiles: [],
		notices: '',
		information: '',
		promptyFlg: PROMPTLY_FLG.PUBLISH_IMMEDIATELY,
		openDate: null,
		openDisplayDate: null,
		openTime: '',
		noSendFlg: NO_SEND_FLG.SEND,
		filePeriod: FILE_PERIOD.DAYS_90, // ファイル保管期間追加
	});
	// エラーのファイル名のリスト
	const [errFileNameMessage, setErrFileNameMessage] = useState('');
	// 新規追加: ブロックされた拡張子リスト
	const [blockedExtensions, setBlockedExtensions] = useState([]);
	const [blockedFileNames, setBlockedFileNames] = useState('');
	// 公開日時の日付形式不正フラグ
	const [openDateFormatErrFlg, setOpenDateFormatErrFlg] = useState(false);
	// 公開日時の過去日判定フラグ
	const [openDatePastErrFlg, setOpenDatePastErrFlg] = useState(false);
	// 公開日時の時刻形式不正フラグ
	const [openTimeFormatErrFlg, setOpenTimeFormatErrFlg] = useState(false);
	// ファイル保管期間の権限フラグ
	const [filePeriodAuthFlg, setRetentionPeriodAuthFlg] = useState(false);

	/**
	 * アップロードAPIの成功時の処理
	 */
	function uploadSuccess() {
		setDialogStatus(DIALOG_STATUS.UPLOAD_COMPLETE_DIALOG);
		var message = "";
		if (formValues.noSendFlg == NO_SEND_FLG.SEND) {
			message = t('message.1000600');
		} else {
			message = t('message.1000610');
		}
		setDialogOpen(true);
		setDialogContent(message);
	};

	/**
	 * アップロードAPIの失敗時の処理
	 * @param {object} error エラーオブジェクト
	 */
	function uploadError(error) {
		if (error.name === 'MaintenanceApiError') {
			navigate('/', { state: { maintenanceFlg: true, } });
		} else if (error.name === 'CustomApiError') {
			//入力テキストに禁則文字が含まれている場合、azureのインフラルールによりエラーとなる
			//ただし、エラーは403 Forbiddenとしか返って来ない（＝禁則文字によるエラーだと判別できない）ため、メッセージを変更する
			const forbidCharPat1 = /.+403 Forbidden.+/;
			const forbidCharPat2 = /.+Microsoft-Azure-Application-Gateway.+/;
			if ((error.message.match(forbidCharPat1)) && (error.message.match(forbidCharPat2))) {
				const message = t('message.1000810');
				setDialogStatus(DIALOG_STATUS.OK_DIALOG);
				setDialogOpen(true);
				setDialogContent(message);

				//認証期限切れの場合は再ログイン
				redirectToLogin();
			} else {
				const message = error.message;
				setDialogStatus(DIALOG_STATUS.OK_DIALOG);
				setDialogOpen(true);
				setDialogContent(message);

				//認証期限切れの場合は再ログイン
				redirectToLogin();
			}
		} else {
			const message = 'アップロード処理でエラーが発生しました。\n(An error occurred during the upload process.)';
			setDialogStatus(DIALOG_STATUS.DETAIL_DIALOG);
			setDialogOpen(true);
			setDialogContent(message);
			setDetailContent(error.stack);

			//認証期限切れの場合は再ログイン
			redirectToLogin();
		}

		//認証期限切れの場合は再ログイン
		redirectToLogin();
	};

	/**
	 * ファイル選択時の処理
	 * @param {object} files 選択したファイルの情報
	 */
	const handleUploadFile = (files) => {
		const selectedFiles = unionWith(
			formValues.selectedFiles,
			files,
			(item1, item2) => item1.name === item2.name,
		);
		
		// 既存のファイル名チェック
		const errFileNameList = selectedFiles
			.filter(file => checkFileName(file.name) === false)
			.map(file => file.name);
		
		// ★ 拡張子ブロックリストチェックを追加 ★
		const blockedFileList = selectedFiles
			.filter(file => isBlockedExtension(file.name, blockedExtensions))
			.map(file => file.name);
		
		if (errFileNameList.length > 0) {
			setErrFileNameMessage(errFileNameList.join(', '));
		} else {
			setErrFileNameMessage('');
		}
		
		// ★ ブロックされたファイルのエラーメッセージを設定 ★
		if (blockedFileList.length > 0) {
			setBlockedFileNames(blockedFileList.join(', '));
		} else {
			setBlockedFileNames('');
		}
		
		setFormValues({ ...formValues, selectedFiles });
	}

	/**
	 * ファイル削除時の処理
	 * @param {object} file 削除したファイルの情報
	 */
	const handleDeleteFile = (file) => {
		const selectedFiles = formValues.selectedFiles.filter((item) => item.name !== file.name);
		
		// 既存のファイル名チェック
		const errFileNameList = selectedFiles
			.filter(file => checkFileName(file.name) === false)
			.map(file => file.name);
		
		// ★ 拡張子ブロックリストチェックを追加 ★
		const blockedFileList = selectedFiles
			.filter(file => isBlockedExtension(file.name, blockedExtensions))
			.map(file => file.name);
		
		if (errFileNameList.length > 0) {
			setErrFileNameMessage(errFileNameList.join(', '));
		} else {
			setErrFileNameMessage('');
		}
		
		// ★ ブロックされたファイルのエラーメッセージを設定 ★
		if (blockedFileList.length > 0) {
			setBlockedFileNames(blockedFileList.join(', '));
		} else {
			setBlockedFileNames('');
		}
		
		setFormValues({ ...formValues, selectedFiles });
	}

	/**
	 * 公開日時で即時公開を選択時の処理
	 */
	const selectPublishImmediately = () => {
		setFormValues({ ...formValues, promptyFlg: PROMPTLY_FLG.PUBLISH_IMMEDIATELY, openDate: null, openDisplayDate: dayjs(null), openTime: '' });
		clearOpenDateErrFlg();
		setOpenTimeFormatErrFlg(false);
	};

	/**
	 * 公開日時の日付入力時の処理
	 * @param {string} date 入力した日付
	 */

	const inputDate = (date) => {
		if (date === '') {
			setFormValues({ ...formValues, openDate: null, openDisplayDate: null });
			clearOpenDateErrFlg();
		} else {
			try {
				// 日付文字列から曜日部分を削除（例：2025/05/Th → 2025/05）
				const cleanDate = date.replace(/\/[A-Za-z][a-z]$/, '');

				// 日付をパース
				const parsedDate = dayjs(cleanDate, 'YYYY/MM/dd', true);

				if (!parsedDate.isValid()) {
					setFormValues({ ...formValues, openDate: date, openDisplayDate: null });
					setOpenDateFormatErrFlg(true);
					setOpenDatePastErrFlg(false);
				} else {
					const dateObj = parsedDate.toDate();
					const today = new Date();
					today.setHours(0, 0, 0, 0);

					if (dateObj >= today) {
						setFormValues({ ...formValues, openDate: dateObj, openDisplayDate: dateObj });
						clearOpenDateErrFlg();
					} else {
						setFormValues({ ...formValues, openDate: dateObj, openDisplayDate: dateObj });
						setOpenDateFormatErrFlg(false);
						setOpenDatePastErrFlg(true);
					}
				}
			} catch (error) {
				console.error('Date parsing error:', error);
				setFormValues({ ...formValues, openDate: date, openDisplayDate: null });
				setOpenDateFormatErrFlg(true);
				setOpenDatePastErrFlg(false);
			}
		}
	};

	// プログレスバー表示用の関数を追加
	const showProgressBar = () => {
		setShowProgress(true);
		setProgressValue(0);
		setUploadStatus('ファイルをアップロード中...');
	};

	// プログレス更新用の関数を追加
	const updateProgress = (percentage) => {
		setProgressValue(percentage);
		// statusの更新は行わない
	};
	// プログレスバー非表示用の関数を追加
	const hideProgressBar = () => {
		setShowProgress(false);
		setProgressValue(0);
		setUploadStatus('');
	};

	/**
	 * 公開日のエラーフラグをfalseに設定する処理
	 */
	const clearOpenDateErrFlg = () => {
		setOpenDateFormatErrFlg(false);
		setOpenDatePastErrFlg(false);
	};

	/**
	 * 公開日時の時刻入力時の処理
	 * @param {string} time 入力した時刻
	 */
	const inputTime = (time) => {
		console.log('Input time received:', time); // デバッグ用
		setFormValues({ ...formValues, openTime: time });

		if (!time || time === '') {
			setOpenTimeFormatErrFlg(false);
			return;
		}


		// 複数のフォーマットを試す
		const isValid =
			dayjs(time, 'HH:mm', true).isValid() ||  // 24時間形式 (例: 14:30)
			dayjs(time, 'hh:mm A', true).isValid() || // 12時間形式 (例: 02:30 PM)
			dayjs(time, 'h:mm A', true).isValid() ||  // 先頭の0なし (例: 2:30 PM)
			dayjs(time, 'h:mm a', true).isValid() ||  // 小文字のam/pm (例: 1:00 am)
			/^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/.test(time) || // 正規表現: HH:mm
			/^([0-1]?[0-9]):[0-5][0-9] (AM|PM|am|pm)$/.test(time); // 正規表現: h:mm AM/PM


		console.log('Is valid time:', isValid); // デバッグ用
		setOpenTimeFormatErrFlg(!isValid);
	};

	/**
	 * アップロードボタン押下時の処理
	 */
	const handleUploadClick = () => {
		var message = "";
		if (formValues.promptyFlg == "0") {
			// openDateはDateオブジェクトなので、dayjsでラップしてからフォーマット
			const openDateStr = dayjs(formValues.openDate).format('YYYY-MM-DD');
			var openDate = toISOStringWithTimezone(dayjs(openDateStr + ' ' + formValues.openTime).toDate());
			var now = toISOStringWithTimezone(new Date());
			//指定した公開日時が現在時刻以前の場合はメッセージ表示
			if (openDate <= now) {
				message = t('message.1001300');
				setDialogStatus(DIALOG_STATUS.OK_DIALOG);
				setDialogOpen(true);
				setDialogContent(message);
			} else {
				message = t('message.1000500');
				setDialogStatus(DIALOG_STATUS.UPLOAD_CONFIRM_DIALOG);
				setConfirmDialogOpen(true);
				setConfirmDialogContent(message);
			}
		} else {
			message = t('message.1000500');
			setDialogStatus(DIALOG_STATUS.UPLOAD_CONFIRM_DIALOG);
			setConfirmDialogOpen(true);
			setConfirmDialogContent(message);
		}
	}


	/**
	 * ダイアログでOKボタン押下時の処理
	 */
	const onOk = () => {
		setDialogStatus(DIALOG_STATUS.NO_DIALOG);
		setDialogOpen(false);
	};

	/**
	 * アップロード時の確認ダイアログでOKボタン押下時の処理
	 */
	const onUploadConfirmOk = async () => {
		// 確認ダイアログを閉じる
		setConfirmDialogOpen(false);
		
		// プログレスバーを表示開始（0%から開始）
		showProgressBar();
		
		try {
			// アップロード用のURLを生成
			const url = setURL(API_URL.UPLOAD_IQVIA_UPLOAD);
			
			// FormDataオブジェクトを作成してアップロードデータを設定
			let formData = new FormData();
			
			// 基本情報をFormDataに追加
			formData.append('orgLevel0Code', formValues.orgCode);      // 企業コード
			formData.append('auditCode', formValues.serviceCode);      // サービスコード
			formData.append('projCode', formValues.projCode);          // プロジェクトコード
			formData.append('notices', formValues.notices);           // 特記事項
			formData.append('information', formValues.information);   // お知らせ情報
			
			// 公開日時が指定されている場合のみ追加
			if (formValues.promptyFlg === PROMPTLY_FLG.PUBLISH_SELECT_DATE) {
				// 日付をYYYY-MM-DD形式にフォーマット
				const openDateStr = dayjs(formValues.openDate).format('YYYY-MM-DD');
				// 日付と時刻を結合してISO文字列に変換
				formData.append('openDate', toISOStringWithTimezone(dayjs(openDateStr + ' ' + formValues.openTime).toDate()));
			};
			
			// メール送信フラグと公開フラグを追加
			formData.append('noSendFlg', formValues.noSendFlg);        // メール送信有無
			formData.append('promptlyFlg', formValues.promptyFlg);     // 即時公開フラグ
			formData.append('filePeriod', formValues.filePeriod); // 追加: ファイル保管期間
			
			// 選択されたファイルをすべてFormDataに追加
			for (let selectedFile of formValues.selectedFiles) {
				formData.append('file', selectedFile);
			}
			
			// プログレス付きアップロードを実行
			await uploadWithProgress(url, formData);
			
		} catch (error) {
			// エラーが発生した場合の処理
			console.error('Upload failed:', error);
			
			// プログレスバーを非表示にする
			hideProgressBar();
			
			// エラーダイアログを表示
			uploadError(error);
		}
	};

	// プログレス付きアップロード関数を改善
	const uploadWithProgress = (url, formData) => {
		return new Promise((resolve, reject) => {
			const xhr = new XMLHttpRequest();
			
			// アップロード進捗の監視
			xhr.upload.addEventListener('progress', (event) => {
				if (event.lengthComputable) {
					const percentComplete = (event.loaded / event.total) * 100;
					updateProgress(Math.round(percentComplete));
				}
			});
			
			xhr.addEventListener('load', () => {
				if (xhr.status === 200) {
					updateProgress(100);
					setTimeout(() => {
						hideProgressBar();
						uploadSuccess();
						resolve(xhr.response);
					}, 500);
				} else if (xhr.status === 400) {
					// ★ 修正: CustomApiError を使用 ★
					const errorMessage = xhr.responseText || `Bad Request: Status ${xhr.status}`;
					console.error('Upload error (400):', errorMessage);
					reject(new CustomApiError(errorMessage));
				} else {
					// ★ 修正: CustomApiError を使用 ★
					const errorMessage = xhr.responseText || `アップロードに失敗しました: ${xhr.status}`;
					reject(new CustomApiError(errorMessage));
				}
			});
			
			xhr.addEventListener('error', (event) => {
				console.error('Upload error:', event);
				reject(new Error('ネットワークエラーが発生しました'));
			});
			
			xhr.addEventListener('timeout', () => {
				console.error('Upload timeout');
				reject(new Error('アップロードがタイムアウトしました'));
			});
			
			// XMLHttpRequestの設定を改善
			xhr.open('POST', url, true);
			xhr.timeout = 4 * 60 * 60 * 1000; // 4時間タイムアウト
			
			// 必要なヘッダーを設定
			xhr.setRequestHeader('Sysrole', SYS_ROLE.UPLOAD_DELIVERY);
			
			// withCredentialsを設定（セッション情報を含める）
			xhr.withCredentials = true;
			
			// エラーハンドリングを改善
			try {
				xhr.send(formData);
			} catch (error) {
				reject(new Error(`送信エラー: ${error.message}`));
			}
		});
	};

	/**
	 * 確認ダイアログでキャンセルボタン押下時の処理
	 */
	const onCancel = () => {
		setDialogStatus(DIALOG_STATUS.NO_DIALOG);
		setConfirmDialogOpen(false);
	};

	/**
	 * 共通納品ファイル管理遷移処理
	 */
	const commonBack = () => {
		const param = {
			service: formValues.serviceCode,
			org: formValues.orgCode,
			proj: formValues.projCode,
		};
		// 納品ファイル管理画面へ遷移
		navigate('/deliveryfilemanagement', { state: param });
	};

	/**
	 * アップロード完了ダイアログでOKボタン押下時の処理
	 */
	const onCompleteOk = () => {
		setDialogStatus(DIALOG_STATUS.NO_DIALOG);
		setDialogOpen(false);
		commonBack();
	};

	/**
	 * キャンセルボタン押下時の処理
	 */
	const handleCancelClick = () => {
		commonBack();
	}

	useEffect(() => {
		(async () => {
			if (location.state === null) {
				// 納品ファイル管理画面へ遷移
				navigate('/deliveryFilemanagement');
				return;
			}
			// ブロックされた拡張子リストを取得
			const extensions = await getBlockedExtensions();
			setBlockedExtensions(extensions);
			// ファイル選択の権限フラグを設定
			setUploadFileSelectorAuthFlg(getFuncroleFlg(SYS_ROLE.UPLOAD_DELIVERY, OBJ_ROLE.UPLOAD_FILE_SELECTOR));
			// 特記事項の権限フラグを設定
			setNoticeAuthFlg(getFuncroleFlg(SYS_ROLE.UPLOAD_DELIVERY, OBJ_ROLE.NOTICES));
			// お知らせの権限フラグを設定
			setInformationAuthFlg(getFuncroleFlg(SYS_ROLE.UPLOAD_DELIVERY, OBJ_ROLE.INFORMATION));
			// 公開日時の権限フラグを設定
			setOpenDateChkAuthFlg(getFuncroleFlg(SYS_ROLE.UPLOAD_DELIVERY, OBJ_ROLE.OPEN_DATE_CHK));
			// 通知メールの送信の権限フラグを設定
			setMailSendChkAuthFlg(getFuncroleFlg(SYS_ROLE.UPLOAD_DELIVERY, OBJ_ROLE.MAIL_SEND_CHK));
			// アップロードボタンの権限フラグを設定
			setUploadFileBtnAuthFlg(getFuncroleFlg(SYS_ROLE.UPLOAD_DELIVERY, OBJ_ROLE.UPLOAD_FILE_BTN));
			// ファイル保管期間の権限フラグを設定 (追加)
			setRetentionPeriodAuthFlg(getFuncroleFlg(SYS_ROLE.UPLOAD_DELIVERY, OBJ_ROLE.FILE_PERIOD_CHK));
			setFormValues({ ...formValues, ...location.state });
			setIsLoading(false);
		})();
	}, []);

	if (isLoading) {
		// ロード中の場合はローディング画面
		return (
			<Loading />
		);
	} else {
		return (
			<>
			{/* 既存のスピナー表示部分を以下に置き換え */}
			{showProgress && (
				<div style={{
					position: 'fixed',
					top: 0,
					left: 0,
					width: '100%',
					height: '100%',
					backgroundColor: 'rgba(0, 0, 0, 0.6)',
					display: 'flex',
					justifyContent: 'center',
					alignItems: 'center',
					zIndex: 10000
				}}>
					<div style={{
						background: 'white',
						padding: '40px',
						borderRadius: '12px',
						textAlign: 'center',
						boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)',
						minWidth: '400px'
					}}>
						<Typography variant="h6" style={{ marginBottom: '20px' }}>
							{uploadStatus}
						</Typography>
						<div style={{
							width: '100%',
							height: '20px',
							backgroundColor: '#f0f0f0',
							borderRadius: '10px',
							overflow: 'hidden',
							marginBottom: '15px'
						}}>
							<div style={{
								height: '100%',
								backgroundColor: '#4CAF50',
								width: `${progressValue}%`,
								transition: 'width 0.3s ease',
								borderRadius: '10px'
							}}></div>
						</div>
						<Typography variant="body2" style={{ color: '#666' }}>
							{Math.round(progressValue)}%
						</Typography>
					</div>
				</div>
			)}			
			<Container className="uploadDelivery" maxWidth="md">
				<Card className="card">
					<CardHeader
						title={t('uploadDelivery')}
						subheader={t('uploadDeliveryScreenDescription')}
					/>
					<CardContent>
						<Grid container>
							<Grid item md={12} className="griditem">
								<TextField
									label={'1. ' + t('selectService')}
									value={formValues.serviceName}
									disabled
									InputLabelProps={{ style: { width: '400px' }}}
								/>
							</Grid>
							<Grid item md={12} className="griditem">
								<TextField
									label={'2. ' + t('selectOrg')}
									value={formValues.orgName}
									disabled
									InputLabelProps={{ style: { width: '400px' }}}
								/>
							</Grid>
							<Grid item md={12} className="griditem">
								<TextField
									label={'3. ' + t('selectProj')}
									value={formValues.projName}
									disabled
									InputLabelProps={{ style: { width: '400px' }}}
								/>
							</Grid>
							<Grid item md={12} className="griditem uploadFileSelector">
								<FileUpload
									label={'4. ' + t('uploadFileSelect')}
									required
									value={formValues.selectedFiles}
									onUpload={handleUploadFile}
									onFileDelete={handleDeleteFile}
									dropAreaLabels={{
										browseLinkText: t('dropAreaBrowseLinkText'),
										hoverText: t('dropAreaHoverText'),
									}}
									disabled={!uploadFileSelectorAuthFlg}
									fullWidth
								/>
								{formValues.selectedFiles.length === 0 && (
									<Typography className='errorMessage' variant='caption'>
										{setMessage(t('message.1000201'), [t('file')])}
									</Typography>
								)}
								{errFileNameMessage.length !== 0 && (
									<Typography className='errorMessage' variant='caption'>
										{setMessage(t('message.1000800'), [errFileNameMessage])}
									</Typography>
								)}
								{blockedFileNames.length !== 0 && (
									<Typography className='errorMessage' variant='caption'>
										{setMessage(t('message.1009000'), [blockedFileNames])}
									</Typography>
								)}
							</Grid>
						</Grid>
						<Grid item md={12} className="griditem notices">
							<TextField
								label={'5. ' + t('notice')}
								helperText={formValues.notices.length > 300 ? setMessage(t('message.1000300'), [t('notice').toLowerCase(), 300]) : t('helperTextNotice')}
								value={formValues.notices}
								onChange={(e) => setFormValues({ ...formValues, notices: e.target.value })}
								error={formValues.notices.length > 300}
								multiline
								minRows="2"
								optional
								fullWidth
								disabled={!noticeAuthFlg}
							/>
						</Grid>
						<Grid item md={12} className="griditem information">
							<TextField
								label={'6. ' + t('information')}
								helperText={formValues.information.length > 300 ? setMessage(t('message.1000300'), [t('information').toLowerCase(), 300]) : t('helperTextInformation')}
								value={formValues.information}
								onChange={(e) => setFormValues({ ...formValues, information: e.target.value })}
								error={formValues.information.length > 300}
								multiline
								minRows="2"
								optional
								fullWidth
								disabled={!informationAuthFlg}
							/>
						</Grid>
						<Grid item md={12} className="griditem openDateChk">
							<InputLabel required>{'7. ' + t('publishedDate')}</InputLabel>
							<Radio
								label={t('publishImmediately')}
								checked={formValues.promptyFlg === PROMPTLY_FLG.PUBLISH_IMMEDIATELY}
								onChange={selectPublishImmediately}
								disabled={!openDateChkAuthFlg || formValues.publishSelectedDate}
							/>
							<br />
							<Radio
								label={t('publishSelectedDatetime')}
								checked={formValues.promptyFlg === PROMPTLY_FLG.PUBLISH_SELECT_DATE}
								onChange={() => setFormValues({ ...formValues, promptyFlg: PROMPTLY_FLG.PUBLISH_SELECT_DATE })}
								disabled={!openDateChkAuthFlg || formValues.publishImmediately}
							/>
							<div>
								<DatePicker
									className='openDate'
									helperText={openDateFormatErrFlg ? t('message.1000400') : openDatePastErrFlg ? t('message.1001300') : ''}
									onInputChange={inputDate}
									minDate={new Date()}
									error={openDateFormatErrFlg || openDatePastErrFlg}
									placeholder="yyyy/mm/dd"
									dateFormat='yyyy/MM/DD'
									disabled={!openDateChkAuthFlg || formValues.promptyFlg === PROMPTLY_FLG.PUBLISH_IMMEDIATELY}
								/>
								<TimePicker
									value={formValues.openTime}
									helperText={openTimeFormatErrFlg ? t('message.1001600') : ''}
									onChange={inputTime}
									error={openTimeFormatErrFlg}
									disabled={!openDateChkAuthFlg || formValues.promptyFlg === PROMPTLY_FLG.PUBLISH_IMMEDIATELY}
								/>
							</div>
							{formValues.promptyFlg === PROMPTLY_FLG.PUBLISH_SELECT_DATE && (!formValues.openDate || formValues.openTime === '') && (
								<Typography className='errorMessage' variant='caption'>
									{t('message.1001400')}
								</Typography>
							)}
						</Grid>
						<Grid item md={12} className="griditem mailSendChk">
							<InputLabel required>{'8. ' + t('sendMail')}</InputLabel>
							<div />
							<Radio
								label={t('sendPublishDate')}
								checked={formValues.noSendFlg === NO_SEND_FLG.SEND}
								onChange={() => setFormValues({ ...formValues, noSendFlg: NO_SEND_FLG.SEND })}
								disabled={!mailSendChkAuthFlg}
							/>
							<br />
							<Radio
								label={t('noSend')}
								checked={formValues.noSendFlg === NO_SEND_FLG.NO_SEND}
								onChange={() => setFormValues({ ...formValues, noSendFlg: NO_SEND_FLG.NO_SEND })}
								disabled={!mailSendChkAuthFlg}
							/>
						</Grid>
						<Grid item md={12} className="griditem filePeriod">
						<InputLabel required style={{ marginTop: '16px' }}>{'9. ' + t('filePeriod')}</InputLabel>
							<div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap', marginTop: '8px' }}>
								<Radio
									label="15日間"
									style={{ marginLeft: '10px', margin: 0, padding: 0 }}
									checked={formValues.filePeriod === FILE_PERIOD.DAYS_15}
									onChange={() => setFormValues({ ...formValues, filePeriod: FILE_PERIOD.DAYS_15 })}
									disabled={!filePeriodAuthFlg}
								/>
								<Radio
									label="30日間"
									style={{ marginLeft: '10px', margin: 0, padding: 0 }}
									checked={formValues.filePeriod === FILE_PERIOD.DAYS_30}
									onChange={() => setFormValues({ ...formValues, filePeriod: FILE_PERIOD.DAYS_30 })}
									disabled={!filePeriodAuthFlg}
								/>
								<Radio
									label="45日間"
									style={{ marginLeft: '10px', margin: 0, padding: 0 }}
									checked={formValues.filePeriod === FILE_PERIOD.DAYS_45}
									onChange={() => setFormValues({ ...formValues, filePeriod: FILE_PERIOD.DAYS_45 })}
									disabled={!filePeriodAuthFlg}
								/>
								<Radio
									label="60日間"
									style={{ marginLeft: '10px', margin: 0, padding: 0 }}
									checked={formValues.filePeriod === FILE_PERIOD.DAYS_60}
									onChange={() => setFormValues({ ...formValues, filePeriod: FILE_PERIOD.DAYS_60 })}
									disabled={!filePeriodAuthFlg}
								/>
								<Radio
									label="75日間"
									style={{ marginLeft: '10px', margin: 0, padding: 0 }}
									checked={formValues.filePeriod === FILE_PERIOD.DAYS_75}
									onChange={() => setFormValues({ ...formValues, filePeriod: FILE_PERIOD.DAYS_75 })}
									disabled={!filePeriodAuthFlg}
								/>
								<Radio
									label="90日間"
									style={{ marginLeft: '10px', margin: 0, padding: 0 }}
									checked={formValues.filePeriod === FILE_PERIOD.DAYS_90}
									onChange={() => setFormValues({ ...formValues, filePeriod: FILE_PERIOD.DAYS_90 })}
									disabled={!filePeriodAuthFlg}
								/>
							</div>
						</Grid>
						<Divider className="divider" type="dark" />
						<Button
							className="uploadFileBtn"
							variant="primary"
							icon={Upload}
							disabled={showProgress || formValues.selectedFiles.length === 0 || errFileNameMessage.length !== 0 || blockedFileNames.length !== 0 || formValues.notices.length > 300 || formValues.information.length > 300 || openDateFormatErrFlg || openDatePastErrFlg || openTimeFormatErrFlg || (formValues.promptyFlg === PROMPTLY_FLG.PUBLISH_SELECT_DATE && (!formValues.openDate || formValues.openTime === ''))}
							onClick={handleUploadClick}
							style={{ display: uploadFileBtnAuthFlg ? "inline-flex" : "none" }}
						>
							{showProgress ? 'アップロード中...' : t('upload')}
						</Button>
						<Button
							className="cancelBtn"
							variant="secondary"
							icon={Close}
							onClick={handleCancelClick}
						>
							{t('cancel')}
						</Button>
					</CardContent>
				</Card>
				{dialogStatus === DIALOG_STATUS.OK_DIALOG && (
					<Dialog
						isOpen={dialogOpen}
						content={dialogContent}
						onOk={onOk}
					/>
				)}
				{dialogStatus === DIALOG_STATUS.DETAIL_DIALOG && (
					<DetailDialog
						isOpen={dialogOpen}
						content={dialogContent}
						detailContent={detailContent}
						onOk={onOk}
					/>
				)}
				{dialogStatus === DIALOG_STATUS.UPLOAD_CONFIRM_DIALOG && (
					<ConfirmDialog
						isOpen={confirmDialogOpen}
						content={confirmDialogContent}
						onOk={onUploadConfirmOk}
						onCancel={onCancel}
					/>
				)}
				{dialogStatus === DIALOG_STATUS.UPLOAD_COMPLETE_DIALOG && (
					<Dialog
						isOpen={dialogOpen}
						content={dialogContent}
						onOk={onCompleteOk}
					/>
				)}
			</Container>
			</>
		);
	}
}

export default UploadDelivery;
